export default __webpack_public_path__ + "static/media/word_thumbnail.f1a37b0e.png";